import { useDispatch } from 'react-redux';
import { BuySubscriptionActions } from 'reactApp/modules/buySubscription/buySubscription.module';
import { updateSubscriptionsRequest } from 'reactApp/modules/subscriptions/subscriptions.module';
import { SUBSCRIPTION_ANALYTICS } from 'reactApp/sections/MobileSubscriptionsPage/MobileSubscription.analytics';
import { HardlyUsedThunkDispatch } from 'reactApp/types/app';
import { renderSubscriptionsModal } from 'reactApp/ui/Mobile/SubscriptionsModal/SubscriptionsModal.helpers';
import { renderPollPopup } from 'reactApp/ui/PollPopup/PollPopup.helpers';
import { sendDwh } from 'reactApp/utils/ga';

import { DwhData } from '../CancelAutoRenewalModal.types';

export const useHandlers = (dwhData: DwhData, onClose: () => void) => {
    const dispatch = useDispatch<HardlyUsedThunkDispatch>();

    const handleCloseSubscription = (id: string) => {
        renderPollPopup({
            isPhone: true,
            onClose: () => {
                sendDwh({
                    ...SUBSCRIPTION_ANALYTICS.MY_TARIFF_CANCEL_STEP2_CANCEL,
                    dwhData,
                });

                dispatch(BuySubscriptionActions.cancelAutorenew(id))
                    .then(() => dispatch(updateSubscriptionsRequest()))
                    .then(onClose);
            },
        });
    };

    const handleGoToAllSubscriptions = () => {
        sendDwh({
            ...SUBSCRIPTION_ANALYTICS.MY_TARIFF_CANCEL_STEP2_SAFE_SUBS,
            dwhData,
        });

        onClose();
        renderSubscriptionsModal();
    };

    return {
        handleCloseSubscription,
        handleGoToAllSubscriptions,
    };
};
